export default __webpack_public_path__ + "static/media/logo1.fc05276c.png";